module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0071.jpg?v=feb5fa52";